const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_1be79f83-3969-45b0-8e96-f7609932169e/artifacts/rxkk1yi8_0E7539D4-89C8-4BC5-A95C-974033632CC9.png";

export function DomainBadge() {
  return (
    <a
      href="https://wakzyautokiosk.com"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="wakzy-domain-badge"
      style={{
        display: "inline-flex",
        boxSizing: "border-box",
        height: "44px",
        padding: "6px 18px 6px 8px",
        alignItems: "center",
        gap: "10px",
        borderRadius: "50px",
        background: "linear-gradient(135deg, #0A2A66 0%, #04060d 100%)",
        border: "1px solid rgba(212, 175, 55, 0.6)",
        boxShadow:
          "0 8px 28px rgba(10, 42, 102, 0.55), 0 0 0 1px rgba(212, 175, 55, 0.2), inset 0 1px 0 rgba(255,255,255,0.08)",
        position: "fixed",
        bottom: "14px",
        right: "14px",
        textDecoration: "none",
        zIndex: 2147483647,
      }}
    >
      <img
        src={LOGO_URL}
        alt="Wakzy"
        style={{
          height: "30px",
          width: "auto",
          filter: "drop-shadow(0 0 6px rgba(212,175,55,0.45))",
        }}
      />
      <span
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          lineHeight: 1.05,
        }}
      >
        <span
          style={{
            color: "#D4AF37",
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            fontSize: "9px",
            fontWeight: 700,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
          }}
        >
          Made by
        </span>
        <span
          style={{
            color: "#FFF",
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            fontSize: "13px",
            fontWeight: 800,
            letterSpacing: "0.02em",
            whiteSpace: "nowrap",
          }}
        >
          wakzyautokiosk.com
        </span>
      </span>
    </a>
  );
}
